export {
  SpinnerBackgroundColor,
  SpinnerColor,
  SpinnerSize,
} from './spinner.component';
